module.exports = __webpack_public_path__ + "img/thumb-intuit-quickbooks-connect@2x.be4e54e6.png";